import ConsultantType from '../consultant/ConsultantType';

/* eslint-disable-next-line arrow-body-style */
const getConsultantFromArray = (consultantIdToGet: number, allConsultants: ConsultantType[]): ConsultantType | null => {
    return allConsultants.find(consultant => consultant.consultantId === consultantIdToGet) ?? null;
};

export default getConsultantFromArray;
